// src/engines/activaRuntime.ts
export type ActivaState =
  | "FlowAligned"
  | "ThresholdState"
  | "EmotionalShift"
  | "BlockedResistance"
  | "BreakthroughEmerging";

export type Features = {
  valence: number;    // [-1..1] but we’ll normalize to [0..1]
  arousal: number;    // [0..1]
  agency: number;     // [0..1]
  friction: number;   // [0..1]
  coherence: number;  // [0..1]
};

type Snapshot = { state: ActivaState; t: number; features: Features };
let last: Snapshot | null = null;

const HOLD_MS = 8000;      // hysteresis to avoid flicker
const SHIFT_WINDOW_MS = 40000;

export function classifyActiva(f: Features, now = Date.now()): ActivaState {
  const prev = last;
  const dv = prev ? Math.abs(f.valence - prev.features.valence) : 0;

  let candidate: ActivaState = "FlowAligned";
  if (f.friction > 0.6 && f.agency < 0.4) candidate = "BlockedResistance";
  else if (dv > 0.25 && now - (prev?.t ?? 0) <= SHIFT_WINDOW_MS) candidate = "EmotionalShift";
  else if (f.arousal > 0.6 && f.friction < 0.5) candidate = "ThresholdState";
  else if (f.coherence > 0.65 && (prev && prev.state !== "FlowAligned")) candidate = "BreakthroughEmerging";
  else if (f.coherence > 0.55) candidate = "FlowAligned";

  if (prev && candidate !== prev.state && (now - prev.t) < HOLD_MS) {
    candidate = prev.state;
  }
  last = { state: candidate, t: now, features: f };
  return candidate;
}

export function normalizeValence(v: number): number {
  // map [-1..1] to [0..1]
  return Math.max(0, Math.min(1, (v + 1) / 2));
}
